import { useParams } from "react-router-dom"

export function useIdParam(): string {
  const { id } = useParams()
  return id || ""
}